import React from "react";

export default function HowItWorks({ steps }) {
  return (
    <section className="mu-section how-it-works-section">
      <div className="container text-center">
        <div className="mu-eyebrow" style={{ color: "var(--mu-purple-700)" }}>Simple Process</div>
        <h2 className="section-title mb-4">How It Works</h2>

        <div className="row g-3">
          {steps.map((step, i) => (
            <div className="col-6 col-lg-3" key={i}>
              <div className="step-card">
                <span className="step-number">{i + 1}</span>
                <h6>{step.title}</h6>
                <p>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
